import {
  ActionIcon,
  Badge,
  Card,
  Group,
  Image,
  SimpleGrid,
  Text,
} from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { IconTrash } from "@tabler/icons-react";
import { useLocation } from "wouter";
import { deleteTrainingDataset } from "../api";

export default function DatasetCard({ dataset }) {
  const [, setLocation] = useLocation();
  return (
    <Card
      onClick={() => setLocation(`training-datasets/${dataset.id}`)}
      withBorder
      style={{ cursor: "pointer" }}
      p="md"
      mb="md"
    >
      <Group mb="xs" justify="space-between">
        <Text>{dataset.name ?? "No  Name "}</Text>
        <Group>
          <Badge
            radius="sm"
            color={dataset.status === "Completed" ? "grape" : "gray"}
          >
            {dataset.status}
          </Badge>
          <ActionIcon
            onClick={(evt) => {
              evt.preventDefault();
              evt.stopPropagation();
              deleteTrainingDataset(dataset.id)
                .then(() => {
                  notifications.show({
                    title: "Dataset deleted",
                    color: "green",
                  });
                  window.location.reload();
                })
                .catch((error) => {
                  notifications.show({
                    title: "An error occurred",
                    message: error.message,
                    color: "red",
                  });
                });
              return false;
            }}
            variant="subtle"
            size="sm"
            color="red"
          >
            <IconTrash size={14} />
          </ActionIcon>
        </Group>
      </Group>
      <SimpleGrid cols={{ base: 3, md: 4, lg: 6 }}>
        {dataset.imageUris.map((uri) => (
          <Image key={uri} alt="" radius="sm" src={uri} width={80} />
        ))}
      </SimpleGrid>
      <Group mt="xs" justify="space-between">
        <Text>{dataset.imageUris.length} images</Text>
        <Text c="dimmed" fz="sm">
          {dataset.created}
        </Text>
      </Group>
    </Card>
  );
}
